<template>
  <button class="round-btn">
    <span class="round-btn-icon">
      <slot name="icon"></slot>
    </span>
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'RoundBtn',
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';

.round-btn {
  display: flex;
  align-items: center;
  color: $bluey-grey;
  margin-right: 1.5em;
  font-weight: 500;
  transition: background-color 250ms ease-out, color 250ms ease-out;

  &:hover {
    opacity: 1;
    color: $faded-blue;

    .round-btn-icon {
      background-color: $bluey-grey;
      color: $color_white;
    }
  }

  .round-btn-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.25em;
    height: 2.25em;
    border-radius: 50%;
    margin-right: 0.5em;
    background-color: $light-periwinkle;
    transition: inherit;
  }

  &.aqua {
    color: $pale-teal;

    .round-btn-icon {
      background-color: $pale-aqua;
    }

    &:hover {
      color: $tea;

      .round-btn-icon {
        background-color: $pale-teal;
        color: $color_white;
      }
    }
  }

  &.pink {
    color: $barbie-pink;

    .round-btn-icon {
      background-color: $pale-pink;
    }

    &:hover {
      color: $dark-pink;

      .round-btn-icon {
        background-color: $barbie-pink;
        color: $color_white;
      }
    }
  }

  &.gold {
    color: $sand;

    .round-btn-icon {
      background-color: $egg-shell;
    }

    &:hover {

      .round-btn-icon {
        background-color: $sand;
        color: $color_white;
      }
    }
  }

  &.trans {
    .round-btn-icon {
      background: none;
    }
  }

  &.transparent:not(:hover):not(:focus):not(:active) {

    .round-btn-icon {
      background-color: transparent;
    }
  }

  &.vertical {
    flex-direction: column;
    justify-content: center;

    .round-btn-icon {
      margin-right: 0;
      margin-bottom: 0.5em;
    }
  }
}
</style>
